import { TransformedLocaleConfig, LocaleName } from '../type';
const baseLocaleConfig = {
  name: 'my',
  months: [
    'ဇန်နဝါရီ',
    'ဖေဖော်ဝါရီ',
    'မတ်',
    'ဧပြီ',
    'မေ',
    'ဇွန်',
    'ဇူလိုင်',
    'ဩဂုတ်',
    'စက်တင်ဘာ',
    'အောက်တိုဘာ',
    'နိုဝင်ဘာ',
    'ဒီဇင်ဘာ',
  ],
  monthsShort: ['ဇန်', 'ဖေ', 'မတ်', 'ဧ', 'မေ', 'ဇွန်', 'ဇူ', 'ဩ', 'စက်', 'အောက်', 'နို', 'ဒီ'],
  weekdays: ['တနင်္ဂနွေ', 'တနင်္လာ', 'အင်္ဂါ', 'ဗုဒ္ဓဟူး', 'ကြာသပတေး', 'သောကြာ', 'စနေ'],
  weekdaysMin: ['တ', 'တ', 'အ', 'ဗ', 'က', 'သ', 'စ'],
  weekdaysShort: ['တနင်္ဂနွေ', 'တနင်္လာ', 'အင်္ဂါ', 'ဗုဒ္ဓဟူး', 'ကြာသပတေး', 'သောကြာ', 'စနေ'],
  formats: {
    LT: 'HH:mm',
    LTS: 'HH:mm:ss',
    lt: 'A h:mm',
    lts: 'A h:mm:ss',
    L: 'D/M/YYYY',
    LL: 'YYYY၊ MMMM D',
    'LL-D': 'YYYY MMMM',
    'LL-Y': 'MMMM D',
    LLL: 'YYYY၊ MMMM D HH:mm',
    'LLL-Y': 'MMMM D HH:mm',
    LLLL: 'YYYY၊ MMMM D၊ dddd HH:mm',
    'LLLL-Y': 'dddd, MMMM D, HH:mm',
    l: 'D/M/YYYY',
    'l-Y': 'D/M',
    ll: 'YYYY၊ MMM D',
    'll-Y': 'D MMM',
    'll-D': 'MMM YYYY',
    lll: 'YYYY၊ MMM D A h:mm',
    'lll-Y': 'D MMM A h:mm',
    llll: 'YYYY၊ MMM D၊ ddd A h:mm',
    'llll-Y': 'MMM D၊ ddd A h:mm',
    'll-Y+w': 'MMM D၊ ddd',
    'LT+to': 'HH:mm ([GMT]Z)',
    'LLL+to': 'YYYY၊ MMMM D HH:mm ([GMT]Z)',
  },
  meridiem: { am: 'နံနက်', pm: 'ညနေ', AM: 'နံနက်', PM: 'ညနေ' },
  past: {
    y: { other: 'ပြီးခဲ့သည့် %s နှစ်' },
    M: { other: 'ပြီးခဲ့သည့် %s လ' },
    w: { other: 'ပြီးခဲ့သည့် %s ပတ်' },
    d: { other: 'ပြီးခဲ့သည့် %s ရက်' },
    h: { other: 'ပြီးခဲ့သည့် %s နာရီ' },
    m: { other: 'ပြီးခဲ့သည့် %s မိနစ်' },
    s: { other: 'ပြီးခဲ့သည့် %s စက္ကန့်' },
  },
  future: {
    y: { other: '%s နှစ်အတွင်း' },
    M: { other: '%s လအတွင်း' },
    w: { other: '%s ပတ်အတွင်း' },
    d: { other: '%s ရက်အတွင်း' },
    h: { other: '%s နာရီအတွင်း' },
    m: { other: '%s မိနစ်အတွင်း' },
    s: { other: '%s စက္ကန့်အတွင်း' },
  },
  pastLong: {
    y: { other: 'ပြီးခဲ့သည့် %s နှစ်' },
    M: { other: 'ပြီးခဲ့သည့် %s လ' },
    w: { other: 'ပြီးခဲ့သည့် %s ပတ်' },
    d: { other: 'ပြီးခဲ့သည့် %s ရက်' },
    h: { other: 'ပြီးခဲ့သည့် %s နာရီ' },
    m: { other: 'ပြီးခဲ့သည့် %s မိနစ်' },
    s: { other: 'ပြီးခဲ့သည့် %s စက္ကန့်' },
  },
  futureLong: {
    y: { other: '%s နှစ်အတွင်း' },
    M: { other: '%s လအတွင်း' },
    w: { other: '%s ပတ်အတွင်း' },
    d: { other: '%s ရက်အတွင်း' },
    h: { other: '%s နာရီအတွင်း' },
    m: { other: '%s မိနစ်အတွင်း' },
    s: { other: '%s စက္ကန့်အတွင်း' },
  },
  abbr: {
    y: { other: '%s နှစ်' },
    M: { other: '%s မိနစ်' },
    w: { other: '%s ပတ်' },
    d: { other: '%s ရက်' },
    h: { other: '%s နာရီ' },
    m: { other: '%s မိနစ်' },
    s: { other: '%s စက္ကန့်' },
  },
  full: {
    y: { other: '%s နှစ်' },
    M: { other: '%s လ' },
    w: { other: '%s ပတ်' },
    d: { other: '%s ရက်' },
    h: { other: '%s နာရီ' },
    m: { other: '%s မိနစ်' },
    s: { other: '%s စက္ကန့်' },
  },
  justNow: 'အခုလေးတင်',
  yesterday: 'မနေ့က',
  today: 'ယနေ့',
  tomorrow: 'မနက်ဖြန်',
  weekStart: 0,
  timeRange: '%$1s – %$2s',
  timeZone: '%$2s %$1s',
  timePref: { 'HH:mm': 'A h:mm' },
  timeRangeStyles: {
    yl: { start: 'YYYY၊ MMMM D', end: 'YYYY၊ MMMM D' },
    'yl-1': { start: 'MMMM D', end: 'YYYY၊ MMMM D' },
    ml: { start: 'MMMM D', end: 'MMMM D' },
    'ml-1': { start: 'YYYY၊ MMMM D', end: 'D' },
    dl: { start: 'MMMM D', end: 'D' },
    y: { start: 'YYYY၊ MMM D', end: 'YYYY၊ MMM D' },
    'y-1': { start: 'YYYY၊ MMM D', end: 'MMM D' },
    m: { start: 'MMM D', end: 'MMM D' },
    'm-1': { start: 'YYYY၊ MMM D', end: 'D' },
    d: { start: 'MMM D', end: 'D' },
    Y: { start: 'YYYY၊ MMM D၊ dddd', end: 'YYYY၊ MMM D၊ dddd' },
    'Y-1': { start: 'YYYY၊ MMM D၊ dddd', end: 'MMM D၊ dddd' },
    M: { start: 'MMM D၊ ddd', end: 'MMM D၊ ddd' },
    D: { start: 'MMM D၊ ddd', end: 'MMM D၊ ddd' },
    yt: { start: 'YYYY၊ MMM D HH:mm', end: 'YYYY၊ MMM D HH:mm' },
    mt: { start: 'MMM D HH:mm', end: 'MMM D HH:mm' },
    dt: { start: 'MMM D HH:mm', end: 'MMM D HH:mm' },
    t: { start: 'HH:mm', end: 'HH:mm' },
    'yt+to': { start: 'YYYY၊ MMM D HH:mm', end: 'YYYY၊ MMM D HH:mm ([GMT]Z)' },
    'mt+to': { start: 'MMM D HH:mm', end: 'MMM D HH:mm ([GMT]Z)' },
    'dt+to': { start: 'MMM D HH:mm', end: 'MMM D HH:mm ([GMT]Z)' },
    't+to': { start: 'HH:mm', end: 'HH:mm ([GMT]Z)' },
  },
};
const localeName: LocaleName = 'my';
export const localeConfig: TransformedLocaleConfig = {
  ...baseLocaleConfig,
  name: localeName,
  ordinal: (n) => `${n}`,
  meridiem: (hour, _, isLowerCase = false): string => {
    if (hour < 12) {
      return isLowerCase ? 'နံနက်' : 'နံနက်';
    } else {
      return isLowerCase ? 'ညနေ' : 'ညနေ';
    }
  },
};
